/** @jsxImportSource @emotion/react */
import { Typography, Layout, Row, Col } from "antd";
import React from "react";
import { TypographySmall } from "../TypographySmall";
import * as Styles from "./styles";

interface LayoutContentProps {
  title: string;
  toolbar?: React.ReactElement;
  iconPath?: string;
}

type LayoutContentPropsType = React.PropsWithChildren<LayoutContentProps>;

const LayoutContentComponent: React.FC<LayoutContentPropsType> = ({
  children,
  title,
  toolbar,
  iconPath,
}: LayoutContentPropsType) => {
  return (
    <Layout css={Styles.containerStyle}>
      <Layout.Header css={Styles.headerStyle}>
        <Row css={Styles.toolbarStyle}>
          <Col span={24}>
            {iconPath ? <img src={iconPath} css={Styles.iconStyle} /> : <></>}
            <Typography.Title css={Styles.titleStyle} ellipsis>
              {title.toUpperCase()}
            </Typography.Title>
          </Col>
          <Col span={24}>{toolbar}</Col>
        </Row>
      </Layout.Header>
      <Layout.Content css={Styles.contentStyle}>{children}</Layout.Content>
      <Layout.Footer css={Styles.footerStyle}>
        <TypographySmall>
          © {new Date().getFullYear()} Away Digital Home. All Rights Reserved.
        </TypographySmall>
      </Layout.Footer>
    </Layout>
  );
};

export const LayoutContent = React.memo(LayoutContentComponent);
